<div class="profilewrapper">
    <div class="profilecontent text-heading-3">My Profile</div>
    <div class="d-flex align-items-start">
     <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
       <button class="nav-link active text-heading-6" id="v-pills-body-tab" data-bs-toggle="pill" data-bs-target="#v-pills-body" type="button" role="tab" aria-controls="v-pills-body" aria-selected="true">Edit Profile</button>
       <button class="nav-link text-heading-6" id="v-pills-implants-tab" data-bs-toggle="pill" data-bs-target="#v-pills-implants" type="button" role="tab" aria-controls="v-pills-implants" aria-selected="false">Change Password</button>
     </div> 
     <div class="tab-content" id="v-pills-tabContent" >
       <div class="tab-pane fade show active" id="v-pills-body" role="tabpanel" aria-labelledby="v-pills-body-tab">
         <app-edit-profile ></app-edit-profile>
       </div> 
       <div class="tab-pane fade" id="v-pills-implants" role="tabpanel" aria-labelledby="v-pills-implants-tab">
          <app-change-password></app-change-password>
       </div>
     </div>
    </div>
 </div>